import { Routes } from '@angular/router';

export const routes: Routes = [
	{
		path: 'fpapp/consentVerification',
		loadComponent: () => import('./webhooks/app-digilocker-webhook/app-digilocker-webhook.component').then(mod => mod?.AppDigilockerWebhookComponent)
	},
	{
		path: 'fpweb/consentVerification',
		loadComponent: () => import('./webhooks/web-digilocker-webhook/web-digilocker-webhook.component').then(mod => mod?.WebDigilockerWebhookComponent)
	},
	{
		path: '**', 
		loadComponent: () => import('./page-not-found/page-not-found.component').then(mod => mod?.PageNotFoundComponent),
	}
];
